import request from "./../utils/request";

export const MODULE_API = {
    getModules: async () => {
        return request.get("/module").then((res) => res.data);
    },

    createModule: async (data) => {
        return request.post("/module", data).then((res) => res.data);
    },

    updateModule: async (moduleName, updatingFields) => {
        return request
            .post(`/module/${moduleName}`, {
                updatingFields,
            })
            .then((res) => res.data);
    },

    deleteModule: async (moduleId) => {
        return request.delete(`/module/${moduleId}`).then((res) => res.data);
    },

    getContactRelatedListRecords: async (moduleName, contactId) => {
        return request
            .get(`/module/records/contact-related-list?moduleName=${moduleName}&contactId=${contactId}`)
            .then((res) => res.data);
    },
    getModuleRelatedList: async (moduleName, tableId, recordId) => {
        return request
            .get(`/module/records/module-related-list?moduleName=${moduleName}&tableId=${tableId}&recordId=${recordId}`)
            .then((res) => res.data);
    },
};
